"use client";
import React from "react";
import { fourData } from "..";
import CardGrid from "../../../CardGrid";
import { GroupHeader } from "../../../ui/Headers";
const Discover = () => {
  return (
    <section className="py-10">
      <div className="wrapper">
        <GroupHeader
          max={1000}
          subheader="Explore a wide range of property types tailored to suit every lifestyle and investment need."
          header="Discover Property Types"
        />
        <CardGrid gap={34} maxColumns={4}>
          {fourData.map((item, index) => {
            return <Card key={index} {...item} />;
          })}
        </CardGrid>
      </div>
    </section>
  );
};
export default Discover;

const Card: React.FC<{
  header: string;
  text: string;
  icon: React.ReactNode;
}> = ({ header, icon, text }) => {
  return (
    <div className="bg-white h-full group transition-colors duration-500 text-secondary-main hover:text-white hover:bg-themeColor rounded-xl p-5">
      <div className="icon p-4 bg-[rgba(var(--primary-color-rgb),0.1)] transition-colors duration-500 group-hover:bg-white mb-6 rounded-md w-max mx-auto">
        <span>{icon}</span>
      </div>
      <h3 className="font-semibold text-center mb-4">{header}</h3>
      <p className="text-center">{text}</p>
    </div>
  );
};
